
import { getToken, setToken, removeToken, getLocalStorage, saveLocalStorage, clearLocalStorage, saveLocalStorageString } from '@/utils/auth'
import { updateCompanyInfo, updatePwdByOldPwd, updateRealName, accountLogin, accountLogout, updatePwdAccount, updateSecurityMobile, getAccountDiscardFlag } from '@/zsm-api-new/login.js'
import { getByMobileAndPlatform, getByMobile, getEnroll, updateFront, getFront, listDataFront, getAuthority } from '@/zsm-api-new/user.js'
import { getAccount } from "@/zsm-api-new/user"
import { formatDate, setCookie } from "@/utils/index"
import CryptoJS from 'crypto-js' // 加密

const state = {
  douyinPlatFormDict: getLocalStorage('douyinPlatFormDict') || 'douyin', // 抖音还是抖店
  stepEle: '', // 当前步骤元素
  sliderUserInfo: false, // 个人信息弹框是否展示
  // getLocalStorage('platformDict').replace(/\"/g,'')||
  loginUserInfo: getLocalStorage('loginUserInfo') || '', // 密报手机号
  securityMobile: getLocalStorage('securityMobile') || '', // 密报手机号
  platformDict: getLocalStorage('platformDict') || 'douyin', // 平台
  // userList:JSON.parse(getLocalStorage.getItem('userList'))||[],//当前手机号下的所有用户
  userInfo: getLocalStorage('zsm-userInfo') || '', // 当前选中平台下的用户
  // JSON.parse(JSON.parse())
  mobile: getLocalStorage('zsm-mobile') || '', // 手机号
  token: getToken('zsm-token'),
  account_valid_warn: '当前讲师账号不支持绑定或删除提现账户，请联系运营同学！', //修改银行卡账号操作提示
  account_valid_warn2: '当前讲师账号不支持修改账号密码操作，请联系运营同学！', //修改密码操作提示
  account_valid_warn_flag: 1 //账号校验状态 0 正常 1禁用
}

const mutations = {
  // 修改账号校验状态
  SET_ACCOUNT_VALID_FLAG: (state, info) => {
    state.account_valid_warn_flag = info
  },
  // 设置用户基本信息
  SET_LOGIN_USER_INFO: (state, info) => {
    saveLocalStorage('loginUserInfo', JSON.stringify(info))
    state.loginUserInfo = getLocalStorage('loginUserInfo')
  },
  // 设置平台
  SET_PLATFORM_DICT: (state, platformDict) => {
    if (platformDict == 'shipinhao_applet') {
      platformDict = 'shipinhao'
    }
    state.platformDict = platformDict;
    saveLocalStorageString('platformDict', platformDict)
  },
  // 设置手机号
  SET_NEW_MOBILE: (state, securityMobile) => {
    state.securityMobile = securityMobile
    saveLocalStorage('securityMobile', securityMobile)
  },
  // 设置手机号
  SET_MOBILE: (state, mobile) => {
    if (mobile == '') {
      state.mobile = ''
      return false
    }
    state.mobile = mobile
    saveLocalStorage('zsm-mobile', mobile)
  },
  // 设置token
  SET_TOKEN: (state, token) => {
    if (token == '') {
      state.token = ''
      return false
    }
    setToken('zsm-token', token)
  },
  // 所有平台下的用户列表
  /*  SET_USER_LIST: (state, list) => {
    if(list==''){
      state.list=[]
      return  false
    }
    state.userList = list
    sessionStorage.setItem('userList', JSON.stringify(list));
  }, */
  // 当前平台下用户基本信息
  SET_USER_INFO: (state, info) => {
    // state.userInfo = info
    saveLocalStorage('zsm-userInfo', JSON.stringify(info))
    // state.userInfo=JSON.stringify(info)
    state.userInfo = getLocalStorage('zsm-userInfo')
  }
}

const actions = {
  /**
   * 校验当前账号是否处于黑名单状态
   * @param id	账号
   * @returns
   */
  getAccountDiscardFlag({ commit }, id) {
    return new Promise((resolve, reject) => {
      getAccountDiscardFlag(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 通过手机号或者frontId获取前端用户
  listDataFront({ commit }, info) {
    return new Promise((resolve, reject) => {
      listDataFront(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 通过手机哈获取前端用户
  getByMobileAndPlatform2({ commit }, info) {
    return new Promise((resolve, reject) => {
      getByMobileAndPlatform(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 通过手机哈获取前端用户
  getByMobileAndPlatform({ commit }, info) {
    return new Promise((resolve, reject) => {
      getByMobileAndPlatform(info).then(response => {
        if (response.result == 'true') {
          commit('SET_USER_INFO', response.data)
          commit('SET_PLATFORM_DICT', response.data.platformDict)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user reset Pwd
  updatePwdAccount({ commit }, info) {
    return new Promise((resolve, reject) => {
      updatePwdAccount(info).then((response) => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  accountLogout({ commit }, id) {
    return new Promise((resolve, reject) => {
      accountLogout(id).then((response) => {
        clearLocalStorage()
        sessionStorage.clear()
        removeToken()
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user login
  accountLogin({ commit }, loginInfo) {
    return new Promise((resolve, reject) => {
      accountLogin(loginInfo).then(response => {
        if (response.result == 'true') {
          commit('SET_MOBILE', loginInfo.id)
          saveLocalStorageString('zsm-login', true)
          saveLocalStorageString('zsm-versions', '1.0.1')
          if (response.data) {
            commit('SET_NEW_MOBILE', response.data.securityMobile)
            commit('SET_TOKEN', response.data.token)
            commit('SET_LOGIN_USER_INFO', response.data)
          }
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户信息
  getFront({ commit }, id) {
    return new Promise((resolve, reject) => {
      getFront(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改用户信息
  updateFront({ commit }, info) {
    return new Promise((resolve, reject) => {
      updateFront(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取用户入驻信息  通过手机号
  getByMobile({ commit }, data) {
    return new Promise((resolve, reject) => {
      getByMobile(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取默认销售人员
  getAuthority({ commit }) {
    return new Promise((resolve, reject) => {
      getAuthority().then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户入驻信息 通过用户id
  getEnroll({ commit }, data) {
    return new Promise((resolve, reject) => {
      getEnroll(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户入驻信息
  updateSecurityMobile({ commit }, info) {
    const { code, id, newMobile } = info
    return new Promise((resolve, reject) => {
      updateSecurityMobile(code, id, newMobile).then(response => {
        if (response.result == 'true') {
          commit('SET_NEW_MOBILE', newMobile)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改密码-根据老密码修改密码
  updatePwdByOldPwd({ commit }, info) {
    const { id, oldPwd, newPwd } = info
    return new Promise((resolve, reject) => {
      updatePwdByOldPwd(id, oldPwd, newPwd).then(response => {
        if (response.result == 'true') {
          commit('SET_NEW_MOBILE', newPwd)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 修改资料-个人的真实姓名
  updateRealName({ commit }, info) {
    const { id, realName } = info
    return new Promise((resolve, reject) => {
      updateRealName(id, realName).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 修改资料-个人的真实姓名
  updateCompanyInfo({ commit }, info) {
    return new Promise((resolve, reject) => {
      const { id, companyCode, companyName } = info
      updateCompanyInfo(id, companyCode, companyName).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 获取账号信息
   * @param {*} id 
   * @returns 
   */
  getAccount({ commit }, id) {
    if (!id) { return }
    return new Promise((resolve, reject) => {
      getAccount(id).then(response => {
        if (response) {
          if (response.data && response.data.expireDate) {
            response.data.expireDateStr = formatDate(response.data.expireDate).timeStrC.substr(0, 11);
            setCookie(response.data.expireDate, 'expire', 3);
          };
          if (response.data && response.data.createDate) {
            response.data.createDateStr = formatDate(response.data.createDate).timeStrC.substr(0, 11);
          };
        }
        resolve(response.data);
      }).catch(error => {
        reject(error)
      })
    })
  },


}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
